._controls_1tvru_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 32px; }
  ._controls-title_1tvru_6 {
    margin-bottom: 6px; }
